
import i18n from '@/locales/init'; 
import store from '@/stores';
import { analyzeGenerator } from './analyzeGenerator';

export const getListentingQuestionAusioContent = (originData: any) => {
  const result: any = [];
 
  for (const group of originData.question) {
    for (let i = 0; i < group.list.length; ++i) {
      const q = group.list[i];
      result.push({
        label: i18n.t('common.dauyan_order_value_question', {v: q.number}),
        startTime: q.start_time / 1000,
        endTime: q.end_time / 1000,
      });
    }
  }

  return result;
};

function getReference(group: any, item: any) {
  const {type} = group;
  const {number, id} = item;
  const inputStr = ' __ ';
  const reference = {content: '', payload: {number, question_id: id}};
  if ([1, 4, 8].indexOf(type) > -1) {
    reference.content = item.title;
  } else if ([5].indexOf(type) > -1) {
    const {collect} = group;
    let result = '';
    collect.split('\n').find((str: string) => {
      const replaceStr = str.replace(new RegExp('\\$' + id + '\\$'), inputStr);
      if (replaceStr !== str) {
        result = replaceStr;
        return true;
      }
    });
    // const result = collect.replace(/\$\d+\$/g, inputStr).replace(/\n/g, '');
    reference.content = result;
    // const {collect} = group;
    // let fStr = '';
    // const collectArr = collect.split(/\$(\d+)\$/);
    // collectArr.find((item: string, index: number) => {
    //   if (index % 2 === 1 && Number(item) === id) {
    //     fStr = collectArr[index + 1];
    //     return true;
    //   }
    // });
    // reference.content = inputStr + fStr.replace(/\n/g, '');
  } else if ([6].indexOf(type) > -1) {
    const result = i18n.t('common.dauyan_question_order_title', {v: number, v1: item.title});
    reference.content = result;
  } else if ([2].indexOf(type) > -1) {
    reference.content = group.collect_option.title;
  } else if ([3].indexOf(type) > -1) {
    const {table: {content}} = group;
    let result = '';
    content.find((cols: any) => {
      return cols.find((str: any) => {
        const replaceStr = str.replace(new RegExp('\\$' + id + '\\$'), inputStr);
        if (replaceStr !== str) {
          result = replaceStr.replace(/\n/g, '');
          return true;
        } else {
          return false;
        }
      });
    });
    reference.content = result;
  } else if ([7].indexOf(type) > -1) {
    reference.content = i18n.t('common.dauyan_question_order_title', {v: number, v1: item.title});
  }
  return reference;
}

export const getListeningQuestionAnalyze = (question_number: number): {answer: any[]; reference: {content: string; payload: any;};} => {
  const originData = store.getState().listening.pageDataAll;
  if (!originData) {
    return {answer: [], reference: {content: '', payload: {}}};
  }
  for (let n = 0; n < originData.length; n++) {
    const originDataItem = originData[n].question.question;
    for (const group of originDataItem) {
      for (let i = 0; i < group.list.length; ++i) {
        const q = group.list[i];
        if (q.number === question_number) {
          return {
            reference: getReference(group, q),
            answer: analyzeGenerator({
              display_answer: q.display_answer,
              ai_analyze: q.ai_analyze,
              audio: {
                start_time: q.start_time,
                end_time: q.end_time,
              },
            }).map((ele: any, index: number) => {
              return {
                key: `${question_number}_${index}`,
                ...ele,
                payload: ele.location,
              };
            })
          };
        }
      }
    }
  }
  

  return {answer: [], reference: {content: '', payload: {}}};

};
